export const termsHtml = `
  <div>
    <b>DO NOT</b> send irreplaceable items.
    <ul>
      <li>
        Upon purchase of Send-in, you will receive a detailed email with address
        and instructions
      </li>
      <li>
        Streamily is not responsible for personal items lost or damaged in
        shipping
      </li>
      <li>Items not received by signing time are signed the next session</li>
      <li>
        Streamily reserves the right to screen orders before they are delivered
        to the artists
      </li>
      <li>Artists may refuse to sign any items at their discretion</li>
      <li>
        Items inappropriate for all ages will not be sent to the artist, will
        not be refunded, and will be returned unsigned
      </li>
      <li>
        Send In items cannot contain human/animal samples, illegal items,
        weapons, marijuana, explosives, gasoline, or air bags
      </li>
      <li>
        Send in items must comply with the prohibitions/restrictions of the
        carrier
      </li>
      <li>
        Please purchase insurance from your carrier for your item. Streamily is
        not responsible for lost, stolen or damage to your item during shipping.
      </li>
      <li>International items exceeding 16oz/1lb/454g will not be returned</li>
      <li>
        Items not signed within 90 days of arrival at Streamily Facility due to
        artist unavailability will be returned and the cost of the autograph
        will be refunded
      </li>
      <li>Streamily is not responsible for lost/damaged items in shipping</li>
      <li>
        All claims for lost/damaged merchandise must be filed through the
        carrier
      </li>
    </ul>
  </div>
`;
